export default __webpack_public_path__ + "static/media/nodata.3a13adc9.svg";